import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { VendorWiseModel } from 'src/app/models/department-app-verification.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { shareReplay} from 'rxjs/operators';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-vendor-wise-report',
  templateUrl: './vendor-wise-report.component.html',
  styleUrls: ['./vendor-wise-report.component.scss']
})
export class VendorWiseReportComponent implements OnInit {
  totalApp:number;
  verfApp:number;
  returnProcessApp:number;
  onTime:number;
  pendingByWeek:number;
  pendingMoreThanWeek:number;
  regectedApp:number;
  miArea:number;
  grandTotalApp:number;
  grandVerfApp:number;
  grandReturnProcessApp:number;
  grandOnTime:number;
  grandPendingByWeek:number;
  grandPendingMoreThanWeek:number;
  grandRegectedApp:number;
  grandMiArea:number;
  arrayIndex:number;
  tempVendorWise: any[];
  vendorWise: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: VendorWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;

  userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  displayMaximizable_rejectedApp:any;
  vendorName:any;
  name:any;
  routePath:any;
  subjectSub:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  selectedYear:any
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    this.routePath=router.split('/')
   
        this.selectedYear=res
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.loadData(this.selectedYear)
      }
          
  );

   
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub =this.reportsService.getAppVerification_VendorWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (Vendor Wise)', '', new Date(), 'Success');

            console.log("dataaa", data)
            if (data?.length > 0) {
              this.vendorWise = data;
              this.tempVendorWise=data;
              this.appVerificationModel = data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
            else{
              this.vendorWise = [];
              this.tempVendorWise=[];
              this.appVerificationModel = [];
              this.arrayIndex=0;
              this.calculateGrandTotal()
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (Vendor Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Vendor Name" : d.VendorName,
          "Total Application": d.TotalApplication,
          "Verified Application": d.VerifiedApplication,
          "Return Process Application": d.ReturnProcessApplication,
          "On Time": d.PendingEarly,
          "Pending by one Week": d.Pending_1Week,
          "Pending more than one Week": d.Pending_Morethan_1Weeks,
          "Rejected Application": d.RejectedApplication,
          "Mi Area": d.MIArea,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'VendorName', header: 'Vendor Name'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      { field: 'ReturnProcessApplication', header: 'Return Process Application' },
      { field: 'PendingEarly', header: 'On Time' },
      { field: 'Pending_1Week', header: 'Pending by one Week' },
      { field: 'Pending_Morethan_1Weeks', header: 'Pending More than one Weeks' },
      { field: 'RejectedApplication', header: 'Rejected Application' },
      { field: 'MIArea', header: 'Mi Area' },
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  // selectFarmerApplication(application) {
  //   if(application.Scheme_Specific_Id){
  //     this.dashboard
  //     .getMIDetailByAppID(application.Scheme_Specific_Id)
  //     .pipe(first())
  //     .subscribe({
  //       next: (res) => {
  //         const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
  //         window.open(link, '_blank');
  //       },
  //       error: (err) => {
  //         console.log("error", err);
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  //   }
  //    else {
  //     this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
  //   }
  // }
  // onRowSelect(event) {
  //   this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Selected',
  //     detail: event.data.name,
  //   });
  // }
  // onRowUnselect(event) {
  //   this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Unselected',
  //     detail: event.data.name,
  //   });
  // }
  // calculation(){
  //   this.filteredData = [];
  //   // this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;
    
  //   this.totalSelectedApp = this.filteredDataForExport.length;
  //   this.filteredDataForExport.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   this.filteredDataForExport.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.Scheme_Specific_Id, 
  //         programID: val.ProgramID,
  //         subsidy_Amt: 0,  
  //         amt_Disbus_to_Vendor: 0, 
  //         amt_Refund_to_Farmer: 0, 
  //         farmerShareToVendor: val.Farmer_Share_To_Vendor, 
  //         state_share_amt: val.State_Share_Payment_Amount, 
  //         centre_share_amt: val.Center_Share_Payment_Amount, 
  //     }) 
  //   })
  // }
  tableDataFunction(event: any) {
    this.tempVendorWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
    onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
       // console.log(event);
      }
      calculateTotalApp() {
        this.totalApp=0;
        this.verfApp=0;
        this.returnProcessApp=0;
        this.onTime=0;
        this.pendingByWeek=0;
        this.pendingMoreThanWeek=0;
        this.regectedApp=0;
        this.miArea=0;      
        for(let i=this.arrayIndex ;this.tempVendorWise.length>10?i<this.arrayIndex+10:i<this.tempVendorWise.length;i++) {
          this.totalApp +=this.tempVendorWise[i].TotalApplication;
          this.verfApp +=this.tempVendorWise[i].VerifiedApplication;
          this.returnProcessApp +=this.tempVendorWise[i].ReturnProcessApplication;
          this.onTime += this.tempVendorWise[i].PendingEarly;
          this.pendingByWeek += this.tempVendorWise[i].Pending_1Week;
          this.pendingMoreThanWeek += this.tempVendorWise[i].Pending_Morethan_1Weeks;
          this.regectedApp += this.tempVendorWise[i].RejectedApplication;
          this.miArea +=this.tempVendorWise[i].MIArea;
        }     
    }

    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandVerfApp=0;
      this.grandReturnProcessApp=0;
      this.grandOnTime=0;
      this.grandPendingByWeek=0;
      this.grandPendingMoreThanWeek=0;
      this.grandRegectedApp=0;
      this.grandMiArea=0;
      for(let vendorData of this.vendorWise) {
        this.grandTotalApp += vendorData.TotalApplication;
        this.grandVerfApp += vendorData.VerifiedApplication;
        this.grandReturnProcessApp += vendorData.ReturnProcessApplication;
        this.grandOnTime += vendorData.PendingEarly;
        this.grandPendingByWeek += vendorData.Pending_1Week;
        this.grandPendingMoreThanWeek += vendorData.Pending_Morethan_1Weeks;
        this.grandRegectedApp += vendorData.RejectedApplication;
        this.grandMiArea += vendorData.MIArea;
    }
    }
    showMaximizableDialog(value:any,status:any,vendorName:any) {
      
      this.name=status;
      this.vendorName=vendorName;
      this.drilldownDetails={
        actionType:"AppVerification",
        
        filterType:"Vendor",
        value:value,
        status:status,
        MIType:""
      }
      
      this.displayMaximizable = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  } 
  showMaximizableDialog_totalApp(value:any,vendorName:any) {
        
        
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"AppVerification",
      
      filterType:"Vendor",
      value:value,
      MIType:""
    }
    
    this.displayMaximizable_totalApp = true;
  
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_pending(value:any,duration:any,vendorName:any) {
        
    if(duration=='early'){
      this.pendingType='On Time'
    }
    if(duration=='1Week'){
      this.pendingType='Pending by Week'
    }
    if(duration=='morethan_1Week'){
      this.pendingType='Pending more than one Week' 
    }
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"AppVerification",
      
      filterType:"Vendor",
      value:value,
      duration:duration,
      MIType:""
    }
    
    this.displayMaximizable_pendingApp = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_rejected(value:any,vendorName:any) {
        
        
    this.vendorName=vendorName;
    this.drilldownDetails={
      actionType:"AppVerification",
      
      filterType:"Vendor",
      value:value,
      MIType:""
    }
    
    this.displayMaximizable_rejectedApp = true;
  
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
    
    

}